<template>
  <div class="container mt-5" v-if="projectEntity !== null">
    <template>
      <participant-profile
          @onChangeBankAccount="handlerChangeBankAccount"
          :project="projectEntity"
          :profile="projectEntity.profile"/>

      <!-- SUPPLIER RESTRICTION NOTIF -->
      <div v-if="projectEntity.supplier != null" class="vx-row">
        <div class="vx-col w-full">
          <SupplierRestrictedData :source="projectEntity.supplier" />
        </div>
      </div>

      <loan-payment-card
          :selectedBankAccount="selectedBankAccount"
          @generatePaymentButtonEvent="showDialog = true"
          @onRequested="onRequestedHandler"
          :project="projectEntity"/>

      <loan-transaction-card
          class="mt-5"
          :project="projectEntity"/>

      <loan-project-invoices-card
          :project="projectEntity"/>

      <template v-if="!projectEntity.isApplicantLoan()">
        <supplier-penalties
            class="mt-5"
            :project="projectEntity"/>

        <impacta-mas-bonus-table
            class="mt-5"
            :bonus="projectEntity.bonus.items"></impacta-mas-bonus-table>
      </template>
      <generate-loan-payment-dialog
          :regenerate="projectEntity.profile.payments.items.length > 0"
          :funding-commission-fee="projectEntity.fundingCommissionFee"
          :project="projectEntity"
          :active.sync="showDialog"
          @onSuccess="onSuccessHandler"/>
    </template>

    <div class="p-5"></div>
  </div>
</template>

<script>
import ParticipantProfile from "@views/admin/loan-payment/participant-profile";
import LoanPaymentCard from "@views/admin/loan-payment/loan-payment-card";
import LoanTransactionCard from "@views/admin/loan-payment/loan-transaction-card";
import LoanProjectInvoicesCard from "@views/admin/loan-payment/loan-project-invoices-card";
import GenerateLoanPaymentDialog from "@views/admin/loan-payment/generate-loan-payment-dialog";
import SupplierPenalties from "@views/admin/loan-payment/supplier-penalties";
import ImpactaMasBonusTable from "@views/admin/loan-payment/impacta-mas-bonus-table";
import {ProjectTransform} from "@/models/LoanPayment/ProjectTransform";

export default {
  name: "loan-payment-view",
  components: {
    ImpactaMasBonusTable,
    SupplierPenalties,
    GenerateLoanPaymentDialog,
    LoanProjectInvoicesCard,
    LoanTransactionCard,
    LoanPaymentCard,
    ParticipantProfile
  },
  props: {
    projectId: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    projectEntity: null,
    project: null,
    showDialog: false,
    selectedBankAccount: null,
  }),
  async mounted() {
    let projectId = this.$route.params.id;
    if (projectId) {
      await this.main(this.$route.params.id);
    }

    if (this.projectId) {
      await this.main(this.projectId);
    }
  },
  methods: {
    handlerChangeBankAccount(bankAccount) {
      this.selectedBankAccount = bankAccount;
    },
    async main(projectId) {
      const {data} = await axios.get(`/api/loan-payment/pid/${projectId}`)
      this.projectEntity = ProjectTransform.fromRequest(data);
    },
    async changeProject(pid) {
      await this.main(pid);
    },
    async onRequestedHandler(data) {
      await this.main(this.$route.params.id)
    },
    onSuccessHandler(data) {
      this.showDialog = false;
      this.projectEntity.profile.payments.clear();
      ProjectTransform.fillPayments(this.projectEntity.profile, data);
    },
  }
}
</script>

<style scoped>

</style>
